import { TeamsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { teamsKeys } from 'app/queries/teams/teamsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof teamsKeys.detailBySlug>>;

export const createFetchTeamBySlugQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId, slug }], signal }: TParams) =>
    call(() => cancelOnSignal(TeamsService.findOneBySlug({ oid: organizationId, slug }), signal));
